import * as fromCurriculum from 'a/pictureThis/content/curriculum';
import { ACTIONS } from 'a/pictureThis/data/constants';
import draggableGroup, { initialState } from './draggableGroup';

const groupById = (state = {}, { type, payload }) => {
  switch (type) {
    case ACTIONS.CREATE_VIEW_MODEL_FROM_CONTENT:
      return createViewModelFromContent(state, payload);

    case ACTIONS.SELECT_LEVEL:
    case ACTIONS.SET_DRAGGABLE_GROUP_INNACTIVE:
      return passActionToEachGroup(state, type, payload);

    case ACTIONS.GROUP_GOT_HOME:
    case ACTIONS.UPDATE_GROUP_OFFSET:
    case ACTIONS.START_GROUP_DRAG:
    case ACTIONS.STOP_GROUP_DRAG:
      return {
        ...state,
        [payload.groupId]: draggableGroup(state[payload.groupId], { type, payload }),
      };

    default:
      return state;
  }
};

const createViewModelFromContent = (state, payload) => {
  const script = fromCurriculum.getStoryScript(payload.levelIndex, payload.contentIndex);
  const draggableGroups = createDraggableGroups(script);
  const nextState = { ...state };
  draggableGroups.forEach((group) => {
    nextState[group.groupId] = group;
  });
  return nextState;
};

const passActionToEachGroup = (groups, type, payload) => {
  const nextState = {};
  Object.keys(groups).forEach((groupId) => {
    nextState[groupId] = draggableGroup(groups[groupId], { type, payload });
  });
  return nextState;
};

const createDraggableGroups = (script) => {
  const groups = [];
  let allpages = [];
  script.forEach((page) => {
    allpages = [...allpages, ...page];
  });
  for (let i = 0; i < allpages.length; i++) {
    groups.push({
      ...initialState,
      uuid: allpages[i].uuid,
      element: allpages[i].element,
      text: allpages[i].text,
      groupId: i,
      offset: { x: 0, y: 0 },
    });
  }
  return groups;
};

export const getGroupById = (state, groupId) => state[groupId];

export default groupById;
